import {Dayjs} from "@dracul/dayjs-frontend";
import BaseOrderService from "@/modules/delivery/core/services/BaseOrderService";

class ScheduleService extends BaseOrderService {

    constructor(order, settings) {
        super(order, settings)
        this.className = "ScheduleService"

        this.now = Dayjs()
    }

    get isReady() {
        //console.log("this.settings",this.settings)
        if (this.settings &&
            this.settings.intervalDeliveryTime >= 0 &&
            this.settings.intervalTakeAwayTime >= 0 &&
            this.settings.preparationTime >= 0 &&
            this.settings.rangeScheduleTime >= 0 &&
            this.settings.extendedBarTime >= 0) {
            return true
        }
        return false
    }

    setNow(dayjs) {
        if (Dayjs.isDayjs(dayjs)) {
            this.now = dayjs
        } else {
            throw new Error("now must be an instance of Dayjs")
        }
    }

    validateCalendar(calendar) {
        if (calendar.className != "CalendarModel") {
            throw new Error("calendar must be an instance of CalendarModel");
        }
        return true
    }


    setExtendedBarTime(value) {
        if (value >= 0) {
            this.settings.extendedBarTime = value
        } else {
            throw new Error("extendedBarTime must be a positive number")
        }
    }

    setIntervalDeliveryTime(interval) {
        if (interval >= 0) {
            this.settings.intervalDeliveryTime = interval
        } else {
            throw new Error("Interval must be a positive number")
        }
    }

    setIntervalTakeAwayTime(interval) {
        if (interval >= 0) {
            this.settings.intervalTakeAwayTime = interval
        } else {
            throw new Error("Interval must be a positive number")
        }
    }

    setDeliveryTime(deliveryTime) {
        if (deliveryTime >= 0) {
            this.settings.deliveryTime = deliveryTime
        } else {
            throw new Error("deliveryTime must be a positive number")
        }
    }

    setPreparationTime(preparationTime) {
        if (preparationTime >= 0) {
            this.settings.preparationTime = preparationTime
        } else {
            throw new Error("preparationTime must be a positive number")
        }
    }

    setRangeScheduleTime(rangeScheduleTime) {
        if (rangeScheduleTime >= 0) {
            this.settings.rangeScheduleTime = rangeScheduleTime
        } else {
            throw new Error("rangeScheduleTime must be a positive number")
        }
    }

    get getDateHour() {
        return this.dateHour
    }

    getAsSoonAsPosible(useDeliveryTime = false){
        let now = Dayjs()
        now = now.add(this.settings.preparationTime, 'm')

        if (useDeliveryTime) {
            now = now.add(this.settings.deliveryTime, 'm')
        }

       return now.format("HH:mm")
    }

    getScheduleOptions(calendar, useRange = false, useExtendedBarTime = false) {


        if (!this.isReady) {
            throw new Error("ScheduleService is not ready. You must initialize it first with timers")
        }

        let extendedTime = useExtendedBarTime ? this.settings.extendedBarTime : 0
        let intervalTime = useRange ? this.settings.intervalDeliveryTime : this.settings.intervalTakeAwayTime

        this.validateCalendar(calendar)

        //Obtengo la hora de comienzo del dia
        let dateHour = Dayjs().startOf('day')

        //Obtengo la fecha de mañana para que sea tope
        let tomorrow = dateHour.add(1, 'day').add(extendedTime, 'minute')

        // Obtengo la hora actual y le sumo el tiempo de preparacion
        let now = this.now.add(this.settings.preparationTime, 'm')

        let working = 0
        let options = []

        //console.log("Hour", hour, "Tomorrow", tomorrow, "Now", now)

        while (working < 1440) {

            if (dateHour.isAfter(now) && calendar.isActive(dateHour, null, extendedTime)) {

                if (useRange) {
                    let hourTo = dateHour.add(this.settings.rangeScheduleTime, 'm')
                    let text = dateHour.format("HH:mm") + " a " + hourTo.format("HH:mm")
                    options.push({text: text, value: dateHour.format("HH:mm")})
                } else {
                    options.push({text: dateHour.format("HH:mm"), value: dateHour.format("HH:mm")})
                }


            }

            dateHour = dateHour.add(intervalTime, 'm')

            working++
            if (dateHour.isAfter(tomorrow)) {
                break
            }
        }
        this.options = options
        return options
    }


}


export default ScheduleService
